module.exports = __webpack_public_path__ + "media/entities/1114-c9c6beac.png";